import { HttpClient } from "@angular/common/http";
import { UrlService } from "./url.service";
import { catchError, EMPTY, Observable } from "rxjs";
import { Injectable } from "@angular/core";

@Injectable({
  providedIn: 'root',
})
export class SourceAccountService {
  private readonly url: string;

  constructor(private readonly http: HttpClient, private readonly urlService: UrlService) {
    this.url = this.urlService.generateUrl('sourceAccount');
  }

  getCompanies(): Observable<string[]> {
    return this.http.get<string[]>(this.url + '/GetCompanies').pipe(
      catchError((error: any) => this.handleError(error))
    );
  }

  private handleError(error: any): Observable<never> {
    return EMPTY;
  }
}
